import { Component } from '@angular/core';

@Component({
  selector: 'app-blank',
  templateUrl: './blank.component.html',
  styleUrls: []
})
export class AppBlankComponent {
}


// WEBPACK FOOTER //
// ./src/app/layouts/blank/blank.component.ts